module.exports = __webpack_public_path__ + "static/media/background_3.958bbd3f.mp3";